import { render, staticRenderFns } from "./fbt-note.vue?vue&type=template&id=a3493c88&scoped=true&"
import script from "./fbt-note.vue?vue&type=script&lang=js&"
export * from "./fbt-note.vue?vue&type=script&lang=js&"
import style0 from "./fbt-note.vue?vue&type=style&index=0&id=a3493c88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3493c88",
  null
  
)

export default component.exports